import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CsBuildupComponent } from './cs-buildup.component';
import { SharedModule } from '../shared/shared.module';
import { ProjectSectionComponent } from './project-section/project-section.component';
import { CsProjectsModule } from '../cs-projects/cs-projects.module';
import { ChargingStationsSectionComponent } from './charging-stations-section/charging-stations-section.component';
import { CsSetupComponent } from './charging-stations-section/cs-setup/cs-setup.component';
import { ElectricityMeterUnitComponent } from './charging-stations-section/electricity-meter-unit/electricity-meter-unit.component';
import { ProjectPreperationSectionComponent } from './project-preperation-section/project-preperation-section.component';
import { CsInstallationSectionComponent } from './cs-installation-section/cs-installation-section.component';
import { LocationSetupComponent } from './cs-installation-section/location-setup/location-setup.component';
import { EntriesTableComponent } from './shared/entries-table/entries-table.component';
import { InstallationDescriptionComponent } from './cs-installation-section/installation-description/installation-description.component';
import { OperationSectionComponent } from './operation-section/operation-section.component';
import { SubsidySectionComponent } from './subsidy-section/subsidy-section.component';
import { SectionComponent } from './shared/section/section.component';
import { ConfirmEmuDeletionDialogComponent } from './charging-stations-section/confirm-emu-deletion-dialog/confirm-emu-deletion-dialog.component';
import { RemoveAffectedEntriesDialogComponent } from './shared/entries-table/remove-affected-entries-dialog/remove-affected-entries-dialog.component';


@NgModule({
  declarations: [
    CsBuildupComponent,
    ProjectSectionComponent,
    ChargingStationsSectionComponent,
    CsSetupComponent,
    ElectricityMeterUnitComponent,
    ProjectPreperationSectionComponent,
    CsInstallationSectionComponent,
    LocationSetupComponent,
    EntriesTableComponent,
    InstallationDescriptionComponent,
    OperationSectionComponent,
    SubsidySectionComponent,
    SectionComponent,
    ConfirmEmuDeletionDialogComponent,
    RemoveAffectedEntriesDialogComponent],
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    CsProjectsModule,
    ImageCropperModule
  ]
})
export class CsBuildupModule { }
